const oidc = {
    logout_success: 'Vous vous êtes déconnecté avec succès.',
};
export default oidc;
